import { render, staticRenderFns } from "./biu-card.vue?vue&type=template&id=7792d796&"
import script from "./biu-card.vue?vue&type=script&lang=ts&"
export * from "./biu-card.vue?vue&type=script&lang=ts&"
import style0 from "./biu-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports